// PrivateRoute.js
import { useEffect, useState, useRef } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { GetOnboardingStatus } from 'components/logic/paymentgateway/GetOnboardingStatus';
import { Backdrop, CircularProgress } from '@mui/material';
import { checkForUpdates } from 'utils/versionCheck';
import { getUserName } from 'utils/auth';

import FeatureBaseProvider from "components/feature-base/featureBase";

const PrivateRoute = () => {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);
  
  // Store the initial userId when component mounts
  const initialUserIdRef = useRef(null);

  useEffect(() => {
    // Capture the userId when the component first mounts
    initialUserIdRef.current = getUserName();
  }, []);

  useEffect(() => {
    const verifySession = async () => {
      try {
        await GetOnboardingStatus(navigate, initialUserIdRef.current);
      } catch (error) {
        console.error('Session check failed:', error);
      } finally {
        setChecking(false);
      }
    };
    verifySession();
  }, [navigate]);

  useEffect(() => {
    // Initial check after app loads
    const initialDelay = setTimeout(() => {
      console.log("Checking for updates...");
      checkForUpdates(); // force first check
    }, 10000);

    // Recheck every 15 minutes
    const intervalId = setInterval(() => {
      checkForUpdates();
    }, 15 * 60 * 1000);

    // Recheck every 60 minutes
    // const intervalSessionID = setInterval(() => {
    //   GetOnboardingStatus(navigate); // Now we can use navigate here
    // }, 60 * 60 * 1000);

    // Check again when tab becomes visible
    const onVisible = () => {
      if (!document.hidden) {
        checkForUpdates();
        GetOnboardingStatus(navigate, initialUserIdRef.current);
      }
    };
    document.addEventListener("visibilitychange", onVisible);

    return () => {
      clearTimeout(initialDelay);
      clearInterval(intervalId);
      //clearInterval(intervalSessionID);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, [navigate]);

  if (checking) {
    return (<Backdrop
      sx={{ color: "#fff", zIndex: 10000000 }}
      open={checking}
    >
      <CircularProgress color="inherit" />
    </Backdrop>) // Or a proper spinner component
  }

  return <FeatureBaseProvider><Outlet /></FeatureBaseProvider>;
};

export default PrivateRoute;
